<template>
  <NoticeItem
    :show-close="isSingleOne"
    :notice-detail="noticeDetail"
    :icon="iconFile"
    :title="title"
    :on-close-icon-click="readNotice"
    :shadow="isSingleOne"
  >
    <div>
      <NotificationTransmissionContentInfo
        v-if="noticeDetail.upload.totalCount"
        :notice="noticeDetail.upload"
        :task-type="TaskType.UPLOAD"
      />
      <NotificationTransmissionContentInfo
        v-if="noticeDetail.download.totalCount"
        :notice="noticeDetail.download"
        :task-type="TaskType.DOWNLOAD"
      />
    </div>
    <template #footer>
      <a-button @click="onActionButtonClick"> 查看 </a-button>
    </template>
  </NoticeItem>
</template>

<script lang="ts">
  const ON_ACTION_BUTTON_CLICK = 'on-action-button-click'
</script>

<script lang="ts" setup>
  import NoticeItem from './NoticeItem.vue'
  import NotificationTransmissionContentInfo from './NotificationTransmissionContentInfo.vue'

  import type { PropType } from 'vue'
  import { computed } from 'vue'
  import iconFile from '@assets/svgs/preload-icon-file.png'
  import { INSTANCE as ApplicationManager } from '@core/application/ApplicationManager'
  import type { TransmissionNotice } from '@/core/Notification/NotificationManager'
  import { INSTANCE as NotificationManager } from '@/core/Notification/NotificationManager'
  import { TaskType } from '@/core/transmission/TransmissionNoticeManager'
  import { useSharedActiveMainHeaderItem, MainHeaderItems } from '@/core/compositions/ActiveMainHeaderItem'

  const { updateCurrentSelectedItem } = useSharedActiveMainHeaderItem()

  const props = defineProps({
    noticeDetail: {
      type: Object as PropType<TransmissionNotice>,
      default: null,
    },
    isSingleOne: {
      type: Boolean,
      default: true,
    },
  })

  const emit = defineEmits([ON_ACTION_BUTTON_CLICK])

  const title = computed(() => ApplicationManager.getAppName(props.noticeDetail.appId))

  const readNotice = () => {
    NotificationManager.markAsReadByNoticeList([props.noticeDetail])
  }

  const onActionButtonClick = () => {
    readNotice()
    updateCurrentSelectedItem(MainHeaderItems.TRANSMISSION_LIST)
    emit(ON_ACTION_BUTTON_CLICK)
  }
</script>
